document.addEventListener('DOMContentLoaded', () => {
  const quickAddModal = document.getElementById('quickAddModal');
  if (!quickAddModal) return;

  const quickAddContent = document.getElementById('quickAddContent');
  const imageContainer = document.getElementById('qaImageContainer');
  const prevBtn = document.getElementById('qaGalleryPrev');
  const nextBtn = document.getElementById('qaGalleryNext');
  const collectionEl = document.getElementById('qaCollection');
  const titleEl = document.getElementById('qaTitle');
  const priceEl = document.getElementById('qaPrice');
  const colorContainer = document.getElementById('qaColorContainer');
  const colorSwatchesEl = document.getElementById('qaColorSwatches');
  const selectedColorNameEl = document.getElementById('qaSelectedColorName');
  const sizeContainer = document.getElementById('qaSizeContainer');
  const sizesEl = document.getElementById('qaSizes');
  const sizeRequiredEl = document.getElementById('qaSizeRequired');
  const addToCartBtn = document.getElementById('qaAddToCart');
  const goToPdpLink = document.getElementById('qaGoToPdp');
  const closeModalBtn = quickAddModal.querySelector('.js-close-modal');

  let currentProduct = null;
  let currentVariant = null;
  let galleryImages = [];
  let currentImageIndex = 0;
  let currentProductColor = '';
  let currentCollectionTitle = '';
  let currentCollectionUrl = '';

  const colorSwatchMap = window.colorSwatchMap || {};

  document.body.addEventListener('click', async (event) => {
    const trigger = event.target.closest('.js-add-to-selection');
    if (!trigger) return;

    event.preventDefault();
    if(sizeRequiredEl) sizeRequiredEl.classList.add('hidden');
    if (quickAddContent) quickAddContent.style.opacity = '0.5';
    quickAddModal.style.display = 'flex';

    currentProductColor = trigger.dataset.productColor || '';
    currentCollectionTitle = trigger.dataset.collectionTitle || '';
    currentCollectionUrl = trigger.dataset.collectionUrl || '#';

    try {
      const response = await fetch(`/products/${trigger.dataset.productHandle}.js`);
      currentProduct = await response.json();
      populateQuickAddModal(currentProduct, currentCollectionTitle, currentCollectionUrl, currentProductColor);
      if (quickAddContent) quickAddContent.style.opacity = '1';
    } catch (error) {
      console.error('Error fetching product data:', error);
      closeQuickAddModal();
    }
  });

  function populateQuickAddModal(product, collectionTitle, collectionUrl, productColor) {
    if (imageContainer) {
      imageContainer.innerHTML = '';
      galleryImages = product.images || [];
      currentImageIndex = 0;
      if (galleryImages.length > 0) {
        galleryImages.forEach((imageSrc, index) => {
          const img = document.createElement('img');
          img.src = imageSrc;
          img.className = 'w-full h-full max-w-[355px] mx-auto object-contain absolute inset-0 transition-opacity duration-300';
          img.style.opacity = (index === 0) ? '1' : '0';
          imageContainer.appendChild(img);
        });
      }
    }
    updateGalleryControls();

    if (collectionEl) {
      collectionEl.textContent = collectionTitle || '';
      collectionEl.href = collectionUrl || '#';
    }
    if (titleEl) titleEl.textContent = product.title;
    if (goToPdpLink) goToPdpLink.href = `/products/${product.handle}`;

    if (colorContainer) {
      if (productColor) {
        colorContainer.style.display = 'block';
        if (selectedColorNameEl) selectedColorNameEl.textContent = productColor;
        colorSwatchesEl.innerHTML = '';
        const normalizedValue = productColor.trim().toLowerCase();
        const colorHex = colorSwatchMap[normalizedValue.replace(/ /g, '')];
        const swatchSpan = document.createElement('span');
        swatchSpan.className = "variant-label w-[28px] h-[28px] flex items-center justify-center rounded-full border border-[#333333] border-2";
        const innerSpan = document.createElement('span');
        innerSpan.className = "block w-[18px] h-[18px] rounded-full";
        if (colorHex) innerSpan.style.backgroundColor = colorHex;
        else innerSpan.style.backgroundColor = '#f0f0f0';
        swatchSpan.appendChild(innerSpan);
        colorSwatchesEl.appendChild(swatchSpan);
      } else {
        colorContainer.style.display = 'none';
      }
    }

    updateSizes();
  }

  function updateSizes() {
    if (!sizesEl) return;
    sizesEl.innerHTML = '';
    const sizeOption = currentProduct.options.find(opt => ['size', 'taglia'].includes(opt.name.toLowerCase())) || currentProduct.options[0];

    if (sizeContainer) {
      sizeContainer.style.display = sizeOption ? 'block' : 'none';
    }

    if (sizeOption) {
      sizeOption.values.forEach(sizeValue => {
        const sizeButton = document.createElement('button');
        sizeButton.type = 'button';
        sizeButton.textContent = sizeValue;
        sizeButton.dataset.size = sizeValue;
        const variantForSize = currentProduct.variants.find(v => v.option1 === sizeValue);

        if (variantForSize && variantForSize.available) {
          sizeButton.className = 'py-2 w-1/5 min-[400px]:w-1/6 text-sm text-left transition-colors cursor-pointer';
        } else {
          sizeButton.className = 'py-2 w-1/5 min-[400px]:w-1/6 text-sm text-left text-gray-400 cursor-not-allowed line-through';
          sizeButton.disabled = true;
        }
        sizesEl.appendChild(sizeButton);
      });
    }

    const fallbackVariant = currentProduct.variants.find(v => v.available) || currentProduct.variants[0];
    updatePriceAndButton(null, fallbackVariant);
  }

  if (sizesEl) {
    sizesEl.addEventListener('click', (event) => {
      if (event.target.tagName !== 'BUTTON' || event.target.disabled) return;
      if(sizeRequiredEl) sizeRequiredEl.classList.add('hidden');
      sizesEl.querySelectorAll('button').forEach(btn => btn.classList.remove('underline'));
      event.target.classList.add('underline');
      const selectedSize = event.target.dataset.size;
      const variant = currentProduct.variants.find(v => v.option1 === selectedSize);
      updatePriceAndButton(variant);
    });
  }

  function updatePriceAndButton(variant, fallbackVariant) {
    currentVariant = variant;
    if (priceEl && addToCartBtn) {
      const variantToShow = variant || fallbackVariant;
      if (variantToShow) {
        priceEl.textContent = new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(variantToShow.price / 100);
      } else {
        priceEl.textContent = '';
      }
      if(variant){
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? (window.textTranslated.addToCart || 'Add to Cart') : 'Sold out';
      } else {
        addToCartBtn.disabled = false;
        addToCartBtn.textContent = window.textTranslated.addToCart || 'Add to Cart';
      }
    }
  }

  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', async () => {
      if (!currentVariant) {
        if(sizeRequiredEl) sizeRequiredEl.classList.remove('hidden');
        return;
      }

      addToCartBtn.textContent = window.textTranslated.adding || 'Adding...';
      addToCartBtn.disabled = true;

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: currentVariant.id,
              quantity: 1,
              properties: {
                "_color": currentProductColor,
                "_collection": currentCollectionTitle
              }
            }]
          })
        });

        if (typeof window.refreshMiniCart === 'function') {
          await window.refreshMiniCart();
        } else {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          if (typeof window.updateCartCount === 'function') window.updateCartCount();
        }

        if (typeof window.openMinicart === 'function') window.openMinicart();

        closeQuickAddModal();

      } catch (error) {
        console.error('Error adding to cart:', error);
        addToCartBtn.textContent = 'Error';
        addToCartBtn.disabled = false;
      }
    });
  }

  function showImage(index) {
    if (!imageContainer) return;
    const images = imageContainer.querySelectorAll('img');
    images.forEach((img, i) => {
      img.style.opacity = (i === index) ? '1' : '0';
    });
    currentImageIndex = index;
    updateGalleryControls();
  }

  function updateGalleryControls() {
    if (!prevBtn || !nextBtn) return;
    const showArrows = galleryImages.length > 1;
    prevBtn.classList.toggle('hidden', !showArrows);
    nextBtn.classList.toggle('hidden', !showArrows);
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      let newIndex = (currentImageIndex - 1 + galleryImages.length) % galleryImages.length;
      showImage(newIndex);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      let newIndex = (currentImageIndex + 1) % galleryImages.length;
      showImage(newIndex);
    });
  }

  function closeQuickAddModal() {
    quickAddModal.style.display = 'none';
    currentProduct = null;
    currentVariant = null;
    currentProductColor = '';
    currentCollectionTitle = '';
    currentCollectionUrl = '';
    if(sizeRequiredEl) sizeRequiredEl.classList.add('hidden');
    if (addToCartBtn) {
      addToCartBtn.textContent = window.textTranslated.addToCart || 'Add to Cart';
      addToCartBtn.disabled = false;
    }
  }

  if (closeModalBtn) {
    closeModalBtn.addEventListener('click', closeQuickAddModal);
  }

  quickAddModal.addEventListener('click', (event) => {
    if (event.target === quickAddModal) {
      closeQuickAddModal();
    }
  });
});
